import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

const PageShell = ({ children, className = "" }) => (
  <div className="noise-overlay relative min-h-screen bg-[#05030A] text-white">
    <Navbar />
    <main className={`pt-32 pb-16 ${className}`}>{children}</main>
    <Footer />
  </div>
);

export const PageHeader = ({ eyebrow, title, subtitle }) => (
  <header className="max-w-5xl mx-auto px-6 md:px-10 mb-14">
    {eyebrow && (
      <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs uppercase tracking-[0.2em] text-white/60 mb-6">
        {eyebrow}
      </div>
    )}
    <h1 className="font-display text-4xl md:text-6xl font-extrabold leading-tight">
      {title}
    </h1>
    {subtitle && (
      <p className="mt-5 text-white/60 text-lg md:text-xl max-w-3xl">{subtitle}</p>
    )}
  </header>
);

export const Prose = ({ children }) => (
  <div className="max-w-3xl mx-auto px-6 md:px-10 text-white/75 leading-relaxed space-y-5 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:md:text-3xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-white [&_h3]:mt-6 [&_h3]:mb-2 [&_a]:text-[#22D3EE] [&_a:hover]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-2">
    {children}
  </div>
);

export default PageShell;
